import isEqual from 'lodash/isEqual';
import { memo } from 'react';

import ActionButton from '../components/ActionButton';
import Card from '../components/Card';
import FieldArrayDeleteButton from '../components/FieldArrayDeleteButton';
import FlexContainer from '../components/FlexContainer';
import HelperText from '../components/HelperText';
import Ledger from '../components/Ledger';
import { MUIAccordionWrapper } from '../components/MUIAccordionWrapper';
import QuestionLibraryTable from '../components/Table';
import QuestionResolutionContainer from '../resolutions/QuestionResolutionContainer';
import Accordion from './../components/Accordion';
import Heading from './../components/Heading';
import Section from './../components/Section';

type ComponentMapperProps = {
  component?: any;
};

/**
 * ComponentMapper component that renders a component based on the component type.
 * @typedef {object} ComponentMapperProps
 * @property {import('../types/component').ComponentTypeProps} component - The component object to be rendered.
 *
 * @param {ComponentMapperProps} props
 * @returns {JSX.Element} The rendered ComponentMapper component.
 */
function ComponentMapper({ component }: ComponentMapperProps) {
  const { type } = component;
  const componentMap = {
    card: <Card component={component} />,
    muiAccordion: <MUIAccordionWrapper component={component} />,
    accordion: <Accordion component={component} />,
    helperText: <HelperText {...component} />,
    heading: <Heading {...component} />,
    ledger: <Ledger {...component} />,
    section: <Section component={component} />,
    actionButton: <ActionButton component={component} />,
    flex: <FlexContainer component={component} />,
    table: <QuestionLibraryTable component={component} />,
    resolution: (
      <QuestionResolutionContainer field={{}} resolutions={[component]} />
    ),
    fieldArrayDeleteButton: <FieldArrayDeleteButton component={component} />,
  };

  return (
    componentMap[type] ?? (
      <p>
        No component with type of <strong>{type}</strong>
      </p>
    )
  );
}

export default memo(ComponentMapper, (prevProps, nextProps) => {
  return isEqual(prevProps.component, nextProps.component);
});
